import { FC } from 'react';
import { useStore } from '@nanostores/react';
import styled from 'styled-components';
import { $movementMode, MovementMode } from '../../store/app';
import { darkBlueBackground, yellow } from '../colors';

const TabGroup = styled.div`
  display: flex;
  gap: 8px;
`;

const TabButton = styled.button<{
  $active: boolean;
}>`
  padding: 8px 14px;
  border-radius: 14px;
  border: none;
  background: ${({ $active }) => ($active ? yellow : darkBlueBackground)};
  color: ${({ $active }) => ($active ? '#000' : '#fff')};
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s;
  outline: none;
  display: flex;
  align-items: center;
`;

// Inline icons on purpose: the existing SVG assets carry <style> blocks with
// colliding generic class names (.b, .c), so new icons use attribute styling
// and currentColor only.
const LinearIcon = () => (
  <svg width="22" height="14" viewBox="0 0 22 14" fill="none">
    <path
      d="M2 7 H17"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M14 3.5 L18 7 L14 10.5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </svg>
);

const PathIcon = () => (
  <svg width="22" height="14" viewBox="0 0 22 14" fill="none">
    <path
      d="M2 7 C 5 1.5, 9 1.5, 11 7 S 16 12.5, 17.5 7"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      fill="none"
    />
    <path
      d="M15 3.5 L18.5 6.5 L14.5 8.5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </svg>
);

// Linear vs path drag recording switch shown next to the playback-mode
// switch while editing a play. Same pill pattern as
// SwitchTransitionModeButton.
export const SwitchMovementModeButton: FC = () => {
  const movementMode = useStore($movementMode);

  return (
    <TabGroup>
      <div
        style={{
          color: '#fff',
          textAlign: 'right',
          alignSelf: 'center',
          fontSize: '10px',
        }}
      >
        Movement
        <br />
        recording:
      </div>
      {/* onPointerUp alongside onClick: iOS drops the synthesized click while
          the main thread is busy with playback re-renders (see ControlButton);
          setting an enum value twice on desktop is harmless. */}
      <TabButton
        $active={movementMode === MovementMode.LINEAR}
        title="Linear: only the end position is saved"
        onClick={() => $movementMode.set(MovementMode.LINEAR)}
        onPointerUp={() => $movementMode.set(MovementMode.LINEAR)}
      >
        <LinearIcon />
      </TabButton>
      <TabButton
        $active={movementMode === MovementMode.PATH}
        title="Path: the drag trail is saved and played back"
        onClick={() => $movementMode.set(MovementMode.PATH)}
        onPointerUp={() => $movementMode.set(MovementMode.PATH)}
      >
        <PathIcon />
      </TabButton>
    </TabGroup>
  );
};
